import { configureStore } from '@reduxjs/toolkit';
import userReducer from './user'
import usersReducer from './users'
import licensesReducer from './licenses'
import signageSlice from './signage'

export default configureStore({
    reducer: {
        user: userReducer,
        users: usersReducer,
        licenses: licensesReducer,
        signage: signageSlice
    },
})
